import script from "./AnalyticsOnboardingSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalyticsOnboardingSection.vue?vue&type=script&setup=true&lang=js"

import "./AnalyticsOnboardingSection.vue?vue&type=style&index=0&id=4989a347&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4989a347"]])

export default __exports__